import { rgbToHex } from './hex2Grayscale';

/**
 * Source: https://gist.github.com/mjackson/5311256
 * @param {*} h 
 * @param {*} s 
 * @param {*} l 
 */
function hslToRgb(h, s, l) {
  var r, g, b;

  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1/6) return p + (q - p) * 6 * t;
      if (t < 1/2) return q;
      if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    }

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;

    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }

  return [ r * 255, g * 255, b * 255 ];
}

export default (hsl, encodeHex=false) => {
  hsl = hsl.replace(/ /g, '');
  var result = /^hsla?\(([\d]+),([\d]+)%,([\d]+)%/i.exec(hsl);

  if (!result) {
    return encodeHex ? '#000000' : 'rbg(0, 0, 0)'
  }

  let [r, g, b] = hslToRgb(
    parseInt(result[1], 10),
    parseInt(result[2], 10) / 100,
    parseInt(result[3], 10) / 100,
  );

  const intensity = Math.round(0.3 * r + 0.59 * g + 0.11 * b);
  return encodeHex 
    ? rgbToHex(intensity, intensity, intensity)
    : `rgb(${intensity}, ${intensity}, ${intensity})` ;
}

